import { isString } from 'lodash';
import { getCurEnvData } from './env/env';

const { env } = getCurEnvData();

export class StorageMgr {
  static REDIRECT_PARAMS = 'REDIRECT_PARAMS';

  // userInfo key
  static USERINFO = 'USERINFO';

  static MARKETINFO = `login_result_h5_${env}`;

  // 交银小程序定位缓存 key
  static BOCOM_LOCATION_CACHE = 'BOCOM_LOCATION_CACHE';

  private _sessionStorage = window.sessionStorage;

  private _localStorage = window.localStorage;

  get redirectParams() {
    const paramsStr = this._sessionStorage[StorageMgr.REDIRECT_PARAMS];
    this._sessionStorage.removeItem(StorageMgr.REDIRECT_PARAMS);
    return isString(paramsStr) ? JSON.parse(paramsStr) : undefined;
  }

  set redirectParams(param:any) {
    this._sessionStorage[StorageMgr.REDIRECT_PARAMS] = JSON.stringify(param);
  }

  getItem(key:string) {
    const valStr = this._localStorage.getItem(key);
    if (valStr) {
      return JSON.parse(valStr);
    }
    return '';
  }

  setItem(key:string, val:any) {
    const valStr = JSON.stringify(val);
    this._localStorage.setItem(key, valStr);
  }

  removeItem(key:string) {
    this._localStorage.removeItem(key);
  }

  /** sessionStorage 获取 */
  getSessionItem(key:string) {
    const valStr = this._sessionStorage.getItem(key);
    if (valStr) {
      return JSON.parse(valStr);
    }
    return '';
  }

  /** sessionStorage 设置 */
  setSessionItem(key:string, val:any) {
    const valStr = JSON.stringify(val);
    this._sessionStorage.setItem(key, valStr);
  }

  /** sessionStorage 移除 */
  removeSessionItem(key:string) {
    this._sessionStorage.removeItem(key);
  }
}

/** 本地缓存管理器实例 */
export const storageMgr = new StorageMgr();
